import { render, staticRenderFns } from "./TextTitle.vue?vue&type=template&id=05009ec4"
import script from "./TextTitle.vue?vue&type=script&lang=js"
export * from "./TextTitle.vue?vue&type=script&lang=js"
import style0 from "./TextTitle.vue?vue&type=style&index=0&id=05009ec4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports